import React from 'react'
import Link from 'gatsby-link'

import underConstruction from '../images/under-construction.png'

const IndexPage = () => (
  <div>
    <img style={{ height: '100%', width: '100%' }} src={underConstruction} />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js